import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from './locales/en/translation.json';
import translationZH from './locales/zh/translation.json';
import translationES from './locales/es/translation.json';

const resources = {
    en: { translation: translationEN },
    zh: { translation: translationZH },
    es: { translation: translationES },
};

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en',
        debug: process.env.NODE_ENV === 'development',
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
            lookupLocalStorage: 'swiftx_portal_language',
        },
    });

type TFunction = (key: string, options?: any) => string;
export const t = i18n.t as TFunction;

export default i18n;
